import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import '../support_req.css'; // make sure this contains the updated styles
import API from '../api';
import { useAuth } from '../AuthContext';

const Support_Request = () => {
  const [rows, setRows] = useState([]);
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;

    const fetchFeedback = async () => {
      try {
        const res = await API.get('/api/feedback');
        setRows(res.data);
      } catch (err) {
        console.error('Error fetching feedback:', err);
      }
    };

    fetchFeedback();
  }, [user, loading]);

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div className="table-container">
        <h2>Feedback / Support Request</h2>
        <table className="stock-news-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Feedback</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.user_id}</td>
                <td>{row.name}</td>
                <td>{row.email}</td>
                <td>{row.phone}</td>
                <td className="multiline-cell">{row.feedback}</td>
                <td>{row.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Support_Request;
